<template>
    <div>
        <CommonPopupFrame :z-index="zIndex" :changeBottom="0" :changeHeight="height + $GlobalStore.navigationBarHeight()" :changeHeightUnit="'px'" :isOpen="isShowBookmarkPopup" :closeCompleteAction="closeBookmarkPopup">
            <div :style="{background: background}" class="main_wrapper">
                <slot></slot>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'BookmarkPopup',
    components: { CommonPopupFrame },
    props: {
        isShowBookmarkPopup: {
            type: Boolean,
            default: false
        },
        closeBookmarkPopup: {
            type: Function,
            default: () => { }
        },
        height: {
            type: Number,
            default: 336
        },
        background: {
            type: String,
            default: 'linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%)'
        },
        zIndex : {
            type : Number,
            default : 10
        }
    }
}
</script>

<style scoped>
.main_wrapper {
    flex: 1;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    padding: 20px;
    padding-top: 16px;
}
</style>